import * as React from "react"
import { NoPermissionScreen } from "@/modules/shared/components/NoPermission"

export const NoAccessPage = () => <NoPermissionScreen variant="page" />
